module.exports = __webpack_public_path__ + "img/printer.d71931e2.jpeg";